import { Component } from '@angular/core';

@Component({
  selector: 'footnote',
  standalone: false,
  templateUrl: './footnote.component.html',
  styleUrl: './footnote.component.scss'
})
export class FootnoteComponent {

}
